import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 3h16","key":"svg-0"}],["path",{"d":"M4 9h16","key":"svg-1"}],["path",{"d":"M4 15h16","key":"svg-2"}],["path",{"d":"M4 21h16","key":"svg-3"}]]

const IconBaselineDensitySmall = createReactComponent('outline', 'baseline-density-small', 'BaselineDensitySmall', __iconNode);

export default IconBaselineDensitySmall;